import { OnPacketType } from '../game/model/interfaces';
import BufferReader from './bufferReader';

const initialBuffer: ArrayBuffer = new ArrayBuffer(1);

class DataStream extends BufferReader {
  private buffer: ArrayBuffer;
  private waitedPacketLength = 0;

  constructor(private onPacket: OnPacketType) {
    super(initialBuffer, 0, 1);
    this.readPosition = 1; // Make initialBuffer processed
    this.buffer = initialBuffer;
    this.onPacket = onPacket;
  }

  push(newBuffer: ArrayBuffer) {
    this.prepareBuffer(newBuffer);
    this.extractPackets();
  }

  private prepareBuffer(newBuffer: ArrayBuffer): void {
    const unreadBytes: number = this.buffer.byteLength - this.readPosition;
    if (unreadBytes === 0) {
      this.buffer = newBuffer;
    } else {
      const combinedArray: Uint8Array = new Uint8Array(new ArrayBuffer(unreadBytes + newBuffer.byteLength));
      combinedArray.set(new Uint8Array(this.buffer, this.readPosition, unreadBytes));
      combinedArray.set(new Uint8Array(newBuffer), unreadBytes);
      this.buffer = combinedArray.buffer;
    }
    this.view = new DataView(this.buffer);
    this.readPosition = 0;
  }

  private extractPackets(): void {
    while (this.readPosition !== this.buffer.byteLength) {
      let packetLength: number | undefined;

      if (this.waitedPacketLength) {
        packetLength = this.waitedPacketLength;
      } else if (this.buffer.byteLength - this.readPosition === 1) {
        return;
      } else {
        packetLength = this.readInt16();
      }

      if (packetLength > this.buffer.byteLength - this.readPosition) {
        this.waitedPacketLength = packetLength;
        return;
      }

      const packet = this.read(packetLength);
      this.waitedPacketLength = 0;
      this.onPacket(packet);
    }
  }
}

export default DataStream;
